import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import {
  QarepaAuthBearerTokenInterceptor,
  QarepaLoadingInterceptor,
} from '@qarepa/common';

export const authenticationProviders = (): Provider[] => {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: QarepaAuthBearerTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: QarepaLoadingInterceptor,
      multi: true,
    },
  ];
};
